import React, { useRef, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import axios, { AxiosError, AxiosResponse } from "axios";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import LoadingPage from '../../components/Loading'
import { userNameHandler, emailHandler, roleHandler, locationHandler } from '../../util/local-storage';

import Typography from '@mui/material/Typography';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { IoReceiptSharp } from 'react-icons/io5';
import { GiWashingMachine, GiFoldedPaper } from 'react-icons/gi';
import { MdLocalLaundryService } from 'react-icons/md';
import { AiOutlineFileDone } from 'react-icons/ai';
import { FaLayerGroup } from 'react-icons/fa';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import { DateTime } from 'luxon';
import { wdfManualStatus } from './hook/usePosApi'
import { updateTrackingStep, updateGrabTrackingUrl, uploadDeliveryImageB64 } from '../Report/utils/api-action'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const EditStatusOrderModal: React.FC = (props) => {

    const userloginName = userNameHandler.get();
    const userRole = useState(roleHandler.get())[0];
    const [display, setDisplay] = useState(props);
    const [btnSubmit, setBtnSubmit] = useState(false);

    const [steps, setSteps] = useState([]);
    const [jobDesc, setJobDesc] = useState([]);
    const [serviceDate, setServiceDate] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [locationName, setLocationName] = useState("");
    const [currentValue, setCurrentValue] = useState(0);
    const [checkTime, setcheckTime] = useState(true);
    const [checkTimeOut, setCheckTimeOut] = useState(false);


    const [loadingPageFlag, setLoadingPageFlag] = useState(0);
    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = useState('');
    const [openNotify, setNotify] = useState(false);
    const [rejectRemark, setRejectRemark] = useState("");
    const eRemark = useRef();
    const [dueDate, setDueDate] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [imgBase64, setImgBase64] = useState(null);
    const [grabUrl, setGrabUrl] = useState('');
    const [imgNote, setImgNote] = useState('');
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);

    const handleClose = (event, reason) => {

        if (reason && reason == "backdropClick" && "escapeKeyDown") {
            return;
        }

        if (props.onClose != null) {
            props.onClose(false);
        }
        setDisplay({ ...props, isDisplay: false });
    };


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleNotify = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(true);
    };


    const onSubmit = async (e) => {
        e.preventDefault();
        setBtnSubmit(true);
        if (dueDate == '') {
            setNotifyMessage('กรุณาระบุวันเวลา');
            setTypeNotify('error')
            handleNotify();
            setBtnSubmit(false);
        } else if (checkTime === false) {
            setNotifyMessage('กรุณาระบุวันเวลาให้มากกว่าเวลาสถานะก่อนหน้า');
            setTypeNotify('error')
            handleNotify();
            setBtnSubmit(false);
        }
        else if (checkTimeOut === true) {
            setNotifyMessage('เวลาเกินกำหนด');
            setTypeNotify('error')
            handleNotify();
            setBtnSubmit(false);
        }
        else if (isRiderStep && !grabUrl?.trim()) {
            setNotifyMessage('กรุณาระบุ Grab Tracking URL สำหรับสถานะ PUP/DLVD');
            setTypeNotify('error');
            handleNotify();
            setBtnSubmit(false);
        }
        else {
            let imagePath = null;
            if (isRiderStep && imgBase64) {
                const uploadRes = await uploadDeliveryImageB64(imgBase64);
                imagePath = uploadRes?.data?.content || null;
                if (!imagePath) {
                    setNotifyMessage('อัปโหลดรูปไม่สำเร็จ กรุณาลองใหม่');
                    setTypeNotify('error');
                    handleNotify();
                    setBtnSubmit(false);
                    return;
                }
            }

            var body = {
                "serviceNo": props.orderNo,
                "status": props.orderDetail?.status_code,
                "trackingDate": dueDate,
                "machineQR": qrCode,
                "updatedBy": userloginName,
                ...(isRiderStep && {
                    "grab_url": grabUrl || null,
                    "tracking_image": imagePath || null,
                    "remark": imgNote || null,
                })
            };

            try {
                const response = await wdfManualStatus(body);
                if (response?.data?.code == 200) {
                    setNotifyMessage('บันทึกสำเร็จ');
                    setTypeNotify('success');
                    handleNotify();
                    props.onSuccess?.();
                }
                else {
                    setNotifyMessage(response?.data?.description);
                    setTypeNotify('error')
                    handleNotify();
                    setBtnSubmit(false);
                }
            } catch {
                setNotifyMessage('บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง');
                setTypeNotify('error')
                handleNotify();
                setBtnSubmit(false);
            }
        }

    };


    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(false);
    };

    useEffect(() => {

        if (props.isDisplay) {
            setLoadingPageFlag(0);
            setDisplay(props);
            setBtnSubmit(false);
            setImgBase64(null);
            setGrabUrl('');
            setImgNote('');
            setIsDragging(false);
        }
    }, [props.isDisplay]);

    const isRiderStep = props.orderDetail?.status_code === 'PUP' || props.orderDetail?.status_code === 'DLVD';

    const readFile = (file) => {
        if (!file?.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = () => { if (typeof reader.result === 'string') setImgBase64(reader.result.split(',')[1]); };
        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (!props.isDisplay || !isRiderStep) return;
        const handler = (e) => {
            const item = [...(e.clipboardData?.items ?? [])].find(i => i.type.startsWith('image/'));
            if (item) readFile(item.getAsFile());
        };
        window.addEventListener('paste', handler);
        return () => window.removeEventListener('paste', handler);
    }, [props.isDisplay, isRiderStep]);

    return (
        <div>
            <Dialog
                open={display.isDisplay}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm" //'xs' | 'sm' | 'md' | 'lg' | 'xl' | false | string
                fullWidth={true}
            >
                <DialogTitle className='border-b-2'>
                    {"แก้ไขสถานะ"} {props.orderDetail?.desc}
                </DialogTitle>
                <DialogContent className='m-4'>

                    <Typography gutterBottom>
                        <div className='  justify-center items-center'>

                            <div className='flex justify-center items-center'>
                                <div className='pl-2 pr-2 w-1/3'><label className='font-bold'>วันเวลา {props.orderDetail?.desc} :</label>

                                </div>
                                <div className='pl-2 pr-2 w-2/3'>
                                    <TextField
                                        size="small"
                                        className='w-full'
                                        type="datetime-local"
                                        defaultValue={dueDate}
                                        onChange={(event) => {
                                            const ark = props.jobcd
                                            const dateTimeCol = ark.map((item) => item?.status_date)
                                            if (props.orderDetail.idx !== 0 && dateTimeCol.some(d => d != null)) {
                                                setcheckTime(true)
                                                setCheckTimeOut(false)

                                                const dateString = dateTimeCol.slice(0, props.orderDetail.idx).filter(d => d != null).at(-1)
                                                const [datePart = "", timePart = "00:00"] =
                                                    (dateString ?? "").split(" ");
                                                const [day, month, year] =
                                                    datePart.split("/");
                                                const [hours, minutes] =
                                                    timePart.split(":");
                                                const beforeDate = new Date(
                                                    year,
                                                    month - 1,
                                                    day,
                                                    hours,
                                                    minutes
                                                );
                                                const checkBeforeState = beforeDate < new Date(event.target.value);
                                                const timediff = new Date(event.target.value) - beforeDate
                                                const timePerState = 8
                                                // console.log(timediff/1000/60/60 > timePerState," : diff_hour > 1 : true < 1 : false")
                                                const checkTimeOut = timediff / 1000 / 60 / 60 > timePerState
                                                if (checkTimeOut === true && props.orderDetail.idx !== 4) {
                                                    setCheckTimeOut(true)
                                                    setDueDate(event.target.value)
                                                    setNotifyMessage(
                                                        "เวลาเกินกำหนด " + timePerState + " ชั่วโมง"
                                                    );
                                                    setTypeNotify("error");
                                                    handleNotify();
                                                    setBtnSubmit(false);
                                                }
                                                if (checkBeforeState === false) {
                                                    setcheckTime(false)
                                                    setDueDate(event.target.value)
                                                    setNotifyMessage(
                                                        "กรุณาระบุวันเวลาให้มากกว่าสถานะก่อนหน้า"
                                                    );
                                                    setTypeNotify("error");
                                                    handleNotify();
                                                    setBtnSubmit(false);
                                                }
                                                setDueDate(event.target.value)
                                            }
                                            else {
                                                setcheckTime(true)
                                                setDueDate(event.target.value)
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                            </div>
                            {props.orderDetail?.status_code == 'WASH' || props.orderDetail?.status_code == 'DRY' ?
                                (
                                    <div className='flex justify-center items-center pt-2'>
                                        <div className='pl-2 pr-2 w-1/3'><label className='font-bold'>รหัสหน้าเครื่อง {props.orderDetail?.machine_select} :</label>
                                        </div>
                                        <div className='pl-2 pr-2 w-2/3'>
                                            <TextField
                                                size="small"
                                                className='w-full'
                                                type="number"
                                                onInput={(e) => {
                                                    e.target.value = (e.target.value).toString().slice(0, 6)
                                                }}
                                                onChange={(e) => { setQrCode(e.target.value); }}
                                            />
                                        </div>
                                    </div>
                                ) : (<div></div>)}

                        </div>
                    </Typography>

                    {/* ── Rider: รูปตะกร้า + Grab URL + Note (เฉพาะ PUP/DLVD) ── */}
                    {isRiderStep && (
                        <div style={{ marginTop: 16 }}>
                            {/* Drop zone */}
                            <div
                                onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                                onDragLeave={() => setIsDragging(false)}
                                onDrop={(e) => { e.preventDefault(); setIsDragging(false); readFile(e.dataTransfer.files?.[0]); }}
                                onClick={() => !imgBase64 && fileInputRef.current?.click()}
                                style={{
                                    border: `2px dashed ${isDragging ? '#303F9F' : '#d1d5db'}`,
                                    borderRadius: 8, padding: 16, textAlign: 'center',
                                    cursor: imgBase64 ? 'default' : 'pointer',
                                    backgroundColor: isDragging ? 'rgba(48,63,159,0.06)' : '#fafafa',
                                    minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    position: 'relative', marginBottom: 12,
                                }}
                            >
                                {imgBase64 ? (
                                    <>
                                        <img src={`data:image/jpeg;base64,${imgBase64}`} alt="preview"
                                            style={{ maxHeight: 140, maxWidth: '100%', borderRadius: 6, objectFit: 'contain' }} />
                                        <button onClick={(e) => { e.stopPropagation(); setImgBase64(null); }}
                                            style={{ position: 'absolute', top: 6, right: 6, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 4, cursor: 'pointer', padding: '2px 6px', fontSize: 12 }}>
                                            ลบ
                                        </button>
                                    </>
                                ) : (
                                    <div style={{ color: '#9ca3af', fontSize: 13 }}>
                                        <div>ลากวางรูปตะกร้าผ้า หรือ<span style={{ color: '#303F9F', textDecoration: 'underline', marginLeft: 4 }}>เลือกไฟล์</span></div>
                                        <div style={{ fontSize: 11, marginTop: 4 }}>หรือ Ctrl+V วางจาก clipboard</div>
                                    </div>
                                )}
                            </div>
                            <input hidden type="file" accept="image/*" ref={fileInputRef}
                                onClick={(e) => (e.target.value = null)}
                                onChange={(e) => readFile(e.target.files?.[0])} />

                            <TextField size="small" fullWidth label="Grab Tracking URL *" value={grabUrl}
                                onChange={(e) => setGrabUrl(e.target.value)}
                                placeholder="วาง Grab Tracking URL ที่นี่" InputLabelProps={{ shrink: true }} sx={{ mb: 1.5 }} />

                            <TextField size="small" fullWidth label="หมายเหตุ (optional)" value={imgNote}
                                onChange={(e) => setImgNote(e.target.value)}
                                InputLabelProps={{ shrink: true }} />
                        </div>
                    )}

                </DialogContent>
                <DialogActions className='border-t-2'>
                    <Button variant="contained" color='error' onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" color='primary' disabled={btnSubmit} onClick={(event) => onSubmit(event)} autoFocus>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>


            <Snackbar open={openNotify} autoHideDuration={6000} onClose={handleCloseDialog} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                key={"top" + "center"}>
                <Alert onClose={handleCloseDialog} severity={typeNotify} sx={{ width: '100%' }}>
                    {notifyMessage}
                </Alert>
            </Snackbar>

        </div>
    );

}

export default EditStatusOrderModal;